import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import DrMaxWrapper from './DrMaxWrapper';

loadDOMComponent({
	selector: 'react-drmax-wrapper',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const prescriptionId = container.getAttribute('prescriptionId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DrMaxWrapper prescriptionId={prescriptionId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
